import { Switch } from "@material-ui/core";
import { colors, withStyles } from "@material-ui/core";

export const SwitchBlueGreen = withStyles({
  switchBase: {
    color: colors.blue[500],
    '&$checked': {
      color: colors.green[500],
    },
    '&$checked + $track': {
      backgroundColor: colors.green[500],
    },
  },
  checked: {},
  track: {
    backgroundColor: colors.blue[400],

  },
})(Switch);